// extracted by mini-css-extract-plugin
module.exports = {"chat":"_iS","counter":"_iT"};